import * as React from "react";
import { useMemo } from "react";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import sortNavigationItems from "components/navigation/util/sortNavigationItems";
import usePluginEntities from "hooks/usePluginEntities";
import mergeNavigationItems from "components/navigation/util/mergeNavigationItems";
import AppConfig from "util/AppConfig";
import NavTabs from "components/common/NavTabs";
const usePageNavigationItems = (page, items) => {
  const allPageNavigationItems = usePluginEntities("pageNavigation");
  return useMemo(() => {
    var _a, _b;
    if (items) {
      return items;
    }
    return (_b = (_a = mergeNavigationItems(allPageNavigationItems).find((item) => item.description === page)) == null ? void 0 : _a.children) != null ? _b : [];
  }, [items, allPageNavigationItems, page]);
};
const PageNavigation = ({ page = void 0, items: itemsProp = void 0 }) => {
  const currentUser = useCurrentUser();
  const items = usePageNavigationItems(page, itemsProp);
  const availableItems = items.filter(
    (item) => (item.requiredFeatureFlag ? AppConfig.isFeatureEnabled(item.requiredFeatureFlag) : true) && (typeof item.useCondition === "function" ? item.useCondition() : true) && isPermitted(currentUser.permissions, item.permissions) && !!item.path
  );
  const formatedItems = sortNavigationItems(availableItems);
  if (formatedItems.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(NavTabs, { items: formatedItems });
};
export default PageNavigation;
